import { Tooltip } from "antd";
import React, { ReactNode } from "react";

interface IUI_ITOTooltip {
  title: string | ReactNode;
  children?: ReactNode;
  isOpen?: boolean;
}

export const UI_ITOTooltip: React.FC<IUI_ITOTooltip> = ({
  title,
  children,
  isOpen,
}) => {
  return (
    <Tooltip
      title={title}
      open={isOpen}
      color="#fff"
      overlayInnerStyle={{ color: "#000" }}
    >
      {children}
    </Tooltip>
  );
};
